// extracted by mini-css-extract-plugin
export default {"ResultSetSlider":"ResultSetSlider_ResultSetSlider__2aqMe"};